// extracted by mini-css-extract-plugin
module.exports = {"icons":"AllowanceRow__icons--26Tal","through":"AllowanceRow__through--2BRBx"};